import { render, staticRenderFns } from "./UpdateInfo.vue?vue&type=template&id=53e98d7b&scoped=true"
import script from "./UpdateInfo.vue?vue&type=script&lang=js"
export * from "./UpdateInfo.vue?vue&type=script&lang=js"
import style0 from "./UpdateInfo.vue?vue&type=style&index=0&id=53e98d7b&scoped=true&lang=css"
import style1 from "./UpdateInfo.vue?vue&type=style&index=1&id=53e98d7b&lang=scss&scoped=true"
import style2 from "./UpdateInfo.vue?vue&type=style&index=2&id=53e98d7b&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e98d7b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53e98d7b')) {
      api.createRecord('53e98d7b', component.options)
    } else {
      api.reload('53e98d7b', component.options)
    }
    module.hot.accept("./UpdateInfo.vue?vue&type=template&id=53e98d7b&scoped=true", function () {
      api.rerender('53e98d7b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dataset/data/UpdateInfo.vue"
export default component.exports